import { SwitchIcon } from '@radix-ui/react-icons';
import clsx from 'clsx';
import { type ReactNode, useEffect, useState } from 'react';

import { DebuggerDrawer } from './components/DebuggerDrawer';
import { isDebuggerEnabled } from './utils/adminDeguggerHeper';

interface AdminDebuggerProps {
  className?: string;
  isOpen?: boolean;
  content?: ReactNode;
}

export const AdminDebugger = (props: AdminDebuggerProps) => {
  const { className, isOpen, content } = props;
  const [showDebugger, setShowDebugger] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(isOpen ?? false);
  useEffect(() => {
    const isEmbeddedInIframe = window.self !== window.top;

    if (isEmbeddedInIframe) {
      setShowDebugger(false);
    } else {
      setShowDebugger(true);
    }
  }, []);

  if (!isDebuggerEnabled || !showDebugger) {
    return null;
  }

  return (
    <div id="admin-debugger" className={clsx('z-[999999999]', className)}>
      <DebuggerDrawer className={'z-[999999999]'} open={open} onClose={setOpen}>
        {content}
      </DebuggerDrawer>

      <div className={'fixed right-0 top-1/2 -translate-y-1/2'}>
        <button
          className={clsx(
            'flex h-10 w-10 flex-col items-center justify-center rounded-l-lg bg-black hover:bg-black/70',
          )}
          onClick={() => setOpen(!open)}
        >
          <SwitchIcon className={clsx('text-xl text-white')} />
        </button>
      </div>
    </div>
  );
};
